// Each language has its own object with the translated content

import { en } from './translations/en';
import { hi } from './translations/hi';
import { kn } from './translations/kn';
import { ml } from './translations/ml';
import { ta } from './translations/ta';
import { te } from './translations/te';
import { ma } from './translations/ma';
import { or } from './translations/or';
import { gu } from './translations/gu';
import { pu } from './translations/pu';
import { as } from './translations/as';
import { be } from './translations/be';

export const translations = {
	english: en,
	tamil: ta,
	telugu: te,
	hindi: hi,
	kannada: kn,
	malayalam: ml,
	marathi: ma,
	oriya: or,
	gujarati: gu,
	punjabi: pu,
	assamese: as,
	bengali: be,
};
